import * as DateFns from 'date-fns';
import dayjs from 'dayjs';

import i18n from '@/lib/i18n/client';
import { AVAILABLE_LANGUAGES } from '@/lib/i18n/constants';

const formatDateObject = (dateValue: Date, format: string) => {
  const locale = AVAILABLE_LANGUAGES.find(
    (x) => x.key === i18n.language
  )?.dataFnsLocale;

  return DateFns.format(dateValue, format, {
    locale,
  });
};

export const formatDate = (value?: string | Date, format: string = 'P - p') => {
  if (value instanceof Date && !isNaN(value.getTime())) {
    return formatDateObject(value, format);
  }

  if (typeof value === 'string') {
    const parsedDate = DateFns.parseISO(value);
    if (DateFns.isValid(parsedDate)) {
      return formatDateObject(parsedDate, format);
    }
  }

  return value?.toString() ?? '';
};

export function formatToDayMonthYear(dateString?: string) {
  if (!dateString) return null;
  return dayjs(dateString).format('DD.MM.YYYY');
}
